// Supabase client + session. Legacy: SUPABASE_URL/ANON_KEY + initAuth (snapshot L8633-8662).
// The anon key is public by design (shipped to every browser); safe to embed.
// Prefer env vars when provided (Vite import.meta.env) so non-prod builds can point elsewhere.
import { createClient, type Session } from '@supabase/supabase-js'
import { state } from './../state'
import { checkOrgTier } from './org'

const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL as string) || 'https://itsjalsymutunbrezhgl.supabase.co'
const SUPABASE_ANON_KEY = (import.meta.env.VITE_SUPABASE_ANON_KEY as string)
  || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml0c2phbHN5bXV0dW5icmV6aGdsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk0MTAyNjQsImV4cCI6MjA5NDk4NjI2NH0.VJUeXfMTj_yqgFZKhMwuZAjPfNsLJ1MBb_rNsQ8m6MQ'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)

/** Callbacks fired when auth state changes (UI re-render hook). */
const listeners = new Set<() => void>()
export function onAuthChange(fn: () => void): void { listeners.add(fn) }
function notify(): void { listeners.forEach((fn) => fn()) }

/**
 * Resolves once the first tier check has settled (org tier loaded, or no
 * session). Lets tier-dependent gates avoid the boot race where a business
 * user transiently reads as 'free'.
 */
let settleTier: () => void
export const tierSettled: Promise<void> = new Promise((r) => { settleTier = r })

/** Check session on load + subscribe to changes (legacy initAuth). */
export async function initAuth(): Promise<void> {
  try {
    const { data: { session: refreshed } } = await supabase.auth.refreshSession()
    const session = refreshed || (await supabase.auth.getSession()).data.session
    applySession(session)
  } catch (e) {
    console.log('initAuth: no session', (e as Error).message)
    settleTier()
  }
  supabase.auth.onAuthStateChange((_event, session) => {
    state.orgTier = null
    applySession(session)
  })
}

function applySession(session: Session | null): void {
  state.currentUser = session?.user ?? null
  notify()
  if (session) void checkOrgTier(session.access_token).finally(() => settleTier())
  else settleTier()
}

export async function signOut(): Promise<void> {
  await supabase.auth.signOut()
  state.currentUser = null
  state.orgTier = null
  notify()
}
